import React, { VoidFunctionComponent } from "react";
interface Props {
    icon: JSX.Element;
    serviceName: string;
    children: JSX.Element;
    isGreyBackground: boolean,
}

export const ServiceItem: VoidFunctionComponent<Props> = ({ icon, serviceName, children, isGreyBackground = false }) => {
    if (!icon || !serviceName) {
        return null;
    }
    return (
        <div className={`service-item ${isGreyBackground && "grey"}`}>
            <div className="service-top">
                {icon}
                <p className="category-name">{serviceName}</p>
            </div>
            <div className="content">{children}</div>
        </div>
    );
};
